import { AlertTypes } from "../components/alerts/Alert";

export interface GenericErrorExtensions<ErrorKeys> {
  details?: {
    key: ErrorKeys;
  }[];
}
export interface ChangesetErrorExtensions<ErrorKeys = never> {
  details?: (
    | {
        key: ErrorKeys;
      }
    | ChangesetError
  )[];
}

export const ChangesetErrorKey = "changesetError" as const;

export interface ChangesetError {
  details: [
    {
      details: {
        message: string;
      };
      errorType: string;
      key: string;
    }
  ];
  key: typeof ChangesetErrorKey;
}

export enum LoginErrorKeys {
  accountLocked = "accountLocked",
  authError = "authError",
  emailVerificationRequired = "emailVerificationRequired",
  error = "error",
  passwordResetRequired = "passwordResetRequired",
}

export interface ErrorsInterface {
  [key: string]: string;
}

export enum SignupErrorKeys {
  authError = "authError",
  emailVerificationRequired = "emailVerificationRequired",
  unverifiedEmail = "unverifiedEmail",
}

export enum PersistTemporaryCartErrorKeys {
  cartIsNotTemporary = "cartIsNotTemporary",
}

export interface ItemWithErrorMsgs {
  id: string;
  errorMsgs: ItemErrorMsg[];
}

export interface ItemErrorMsg {
  alertType: AlertTypes;
  title: string;
  note: string;
}

export interface CartErrorMsg {
  alertType: AlertTypes;
  errorKey: SubmitOrderErrorKeys | ProcessSubscriptionNowErrorKeys;
  msg: string;
}

export interface ItemErrorDetail {
  id: string;
  inventoryQty?: number;
  purchaseQtyLimit?: number;
}

export interface VariantErrorDetail {
  cartItemId: string;
  inventory?: number;
  maxQuantity?: number;
  minQuantity?: number;
  quantity?: number;
}

export enum ProcessSubscriptionNowErrorKeys {
  outOfStock = "outOfStock",
  lowStock = "lowStock",
  paymentNotAccepted = "paymentNotAccepted",
}

export enum SubmitOrderErrorKeys {
  archivedItemsInCart = "archivedItemsInCart",
  assortmentExclusion = "assortmentExclusion",
  assortmentInclusion = "assortmentInclusion",
  bundleItemWithoutBundle = "bundleItemWithoutBundle",
  bundleOnlyWithoutBundle = "bundleOnlyWithoutBundle",
  createSubmittedOrder = "createSubmittedOrder",
  guestCartContainsSubscription = "guestCartContainsSubscription",
  insufficientLoyaltyBalance = "insufficientLoyaltyBalance",
  invalidLoyaltyReward = "invalidLoyaltyReward",
  lowStock = "lowStock",
  loyaltyRedemptionFailure = "loyaltyRedemptionFailure",
  minimumPurchaseAmount = "minimumPurchaseAmount",
  minimumPurchaseQuantity = "minimumPurchaseQuantity",
  noGiftCardBalance = "noGiftCardBalance",
  outOfStock = "outOfStock",
  paymentNotAccepted = "paymentNotAccepted",
  purchaseQtyLimit = "purchaseQtyLimit",
  scheduledOrderOutOfStock = "scheduledOrderOutOfStock",
  shippingAddressValidation = "shippingAddressValidation",
  subscriptionOnlyInCart = "subscriptionOnlyInCart",
  subscriptionsNotAllowed = "subscriptionsNotAllowed",
  unableToApplyGiftCard = "unableToApplyGiftCard",
  unableToDeleteCart = "unableToDeleteCart",
  unapprovedItemsInCart = "unapprovedItemsInCart",
  unverifiedEmail = "unverifiedEmail",
  userWithoutAccount = "userWithoutAccount",
  variantArchived = "variantArchived",
  variantBelowMinQuantity = "variantBelowMinQuantity",
  variantExceedsMaximumQuantity = "variantExceedsMaximumQuantity",
  variantInvalid = "variantInvalid",
  variantInvalidSubscription = "variantInvalidSubscription",
  variantLowStock = "variantLowStock",
  variantOutOfStock = "variantOutOfStock",
  variantSubscriptionsNotAllowed = "variantSubscriptionsNotAllowed",
  variantZipCodeRestriction = "variantZipCodeRestriction",
  virtualItemsInCart = "virtualItemsInCart",
  zipCodeRestrictionOnItems = "zipCodeRestrictionOnItems",
  zipCodeRestrictionOnTenant = "zipCodeRestrictionOnTenant",
}
